export const DetailFilterData = [
    {
        "idFromColumnFilter": "position",
        "id": "position",
    },
    {
        "idFromColumnFilter": "name",
        "id": "name",
    },
    {
        "idFromColumnFilter": "length",
        "id": "length",
    },
    {
        "idFromColumnFilter": "width",
        "id": "width",
    },
    {
        "idFromColumnFilter": "height",
        "id": "height",
    },
    {
        "idFromColumnFilter": "l1",
        "id": "l1",
    },
    {
        "idFromColumnFilter": "l2",
        "id": "l2",
    },
    {
        "idFromColumnFilter": "w1",
        "id": "w1",
    },
    {
        "idFromColumnFilter": "w2",
        "id": "w2",
    },
    {
        "idFromColumnFilter": "groove",
        "id": "groove",
    },
    {
        "idFromColumnFilter": "quantity",
        "id": "quantity",
    },
    {
        "idFromColumnFilter": "reserveLimit",
        "id": "reserveLimit",
    },
    {
        "idFromColumnFilter": "nameMaterial",
        "id": "nameMaterial",
    },
    {
        "idFromColumnFilter": "modelSeries",
        "id": "modelSeries",
    },
    {
        "idFromColumnFilter": "groupModel",
        "id": "groupModel",
    },
    {
        "idFromColumnFilter": "materialOptionOrganizationName",
        "id": "materialOptionOrganizationName",
    },
    {
        "idFromColumnFilter": "orderNumber",
        "id": "orderNumber",
    },
    {
        "idFromColumnFilter": "sequentialNumber",
        "id": "sequentialNumber",
    },
]
